export const LAUNCH_DARKLY_CLIENT_ID = import.meta.env.VITE_REACT_APP_LD_CLIENT_ID || "";
